/**
 * 从「新增/编辑订单」跳转到客户/品牌管理前暂存表单，返回后恢复，避免重复录入。
 */
const DRAFT_KEY = 'erp_sales_order_form_draft_v1'
const PENDING_PICK_KEY = 'erp_sales_order_form_pending_pick_v1'
/** 从订单明细跳转「新增客户材料名称」时记录目标行，保存后回填该行 */
const MCN_TARGET_ROW_KEY = 'erp_order_mcn_target_row_v1'

export function setMaterialCustomerNameTargetRowKey(rowKey) {
  try {
    if (rowKey) sessionStorage.setItem(MCN_TARGET_ROW_KEY, String(rowKey))
  } catch (e) {
    console.error('setMaterialCustomerNameTargetRowKey', e)
  }
}

export function consumeMaterialCustomerNameTargetRowKey() {
  try {
    const k = sessionStorage.getItem(MCN_TARGET_ROW_KEY)
    sessionStorage.removeItem(MCN_TARGET_ROW_KEY)
    return k || null
  } catch {
    return null
  }
}

export function saveOrderCreateDraft(formSnapshot) {
  try {
    sessionStorage.setItem(DRAFT_KEY, JSON.stringify(formSnapshot))
  } catch (e) {
    console.error('saveOrderCreateDraft', e)
  }
}

export function loadOrderCreateDraft() {
  try {
    const s = sessionStorage.getItem(DRAFT_KEY)
    return s ? JSON.parse(s) : null
  } catch {
    return null
  }
}

export function clearOrderCreateDraft() {
  try {
    sessionStorage.removeItem(DRAFT_KEY)
  } catch (_) {
    /* ignore */
  }
}

/** 新增客户/品牌成功后写入，返回订单页时自动选中 */
export function setOrderCreatePendingPick(partial) {
  try {
    sessionStorage.setItem(PENDING_PICK_KEY, JSON.stringify(partial || {}))
  } catch (e) {
    console.error('setOrderCreatePendingPick', e)
  }
}

export function consumeOrderCreatePendingPick() {
  try {
    const s = sessionStorage.getItem(PENDING_PICK_KEY)
    sessionStorage.removeItem(PENDING_PICK_KEY)
    return s ? JSON.parse(s) : null
  } catch {
    return null
  }
}

export function clearOrderCreatePendingPick() {
  try {
    sessionStorage.removeItem(PENDING_PICK_KEY)
  } catch (_) {
    /* ignore */
  }
}

/**
 * 将 JSON 草稿转为可写入订单表单的快照（日期等）。
 */
export function hydrateOrderFormFromDraft(raw) {
  const d = typeof raw === 'string' ? JSON.parse(raw) : JSON.parse(JSON.stringify(raw))
  const toDate = (v) => {
    if (v == null || v === '') return null
    const x = new Date(v)
    return Number.isNaN(x.getTime()) ? null : x
  }
  d.order_entry_date = toDate(d.order_entry_date) || new Date()
  d.order_date = toDate(d.order_date) || new Date()
  if (!Array.isArray(d.items)) d.items = []
  d.items = d.items.map((row, idx) => ({
    ...row,
    expected_delivery_date: row.expected_delivery_date
      ? toDate(row.expected_delivery_date)
      : null,
    _clientRowKey:
      row._clientRowKey || `r-${Date.now()}-${idx}-${Math.random().toString(36).slice(2, 11)}`
  }))
  return d
}
